import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BulkSummaryCards from "../payrole-tabs/BulkSummaryCards";
import PayrollHistoryTableView from "../payrole-tabs/PayrollHistoryTableView";
import { fetchPayroleHistoryData } from "../../../redux/payrole-reducers/payroleSlice";
import Loader from "../../ui/Loader";

const History = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const { payroleHistoryData, payroleHistoryLoading, payroleHistoryError } =
    useSelector((state) => state.payrole);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);

  const iniAllFilter = {
    selectedYear: "",
    selectedMonth: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    year: allFilters.selectedYear?.value || "",
    month: allFilters.selectedMonth?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniDatas = {
    pagination: [],
    allData: [],
    trendData: [],
    statsData: {},
  };
  const [allDatas, setAllDatas] = useState(iniDatas);

  const getPayroleHistoryData = (filters) => {
    dispatch(
      fetchPayroleHistoryData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  useEffect(() => {
    getPayroleHistoryData(filters);
  }, [filters]);

  useEffect(() => {
    if (
      !payroleHistoryLoading &&
      !payroleHistoryError &&
      payroleHistoryData?.status
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: payroleHistoryData?.data || [],
        pagination: payroleHistoryData?.pagination || [],
        trendData: payroleHistoryData?.trends || [],
        statsData: payroleHistoryData?.stats || {},
      }));
    } else {
      setAllDatas(iniDatas);
    }
  }, [payroleHistoryLoading, payroleHistoryError, payroleHistoryData]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      year: allFilters.selectedYear?.value || "",
      month: allFilters.selectedMonth?.value || "",
    }));
  }, [isPage, pageLimit, allFilters.selectedYear, allFilters.selectedMonth]);

  return (
    <>
      {/* <div className="pp-wrapper pp-history-container"> */}
        {payroleHistoryLoading ? (
          <Loader />
        ) : (
          <BulkSummaryCards statsData={allDatas?.statsData} isHistory={true} />
        )}

        <PayrollHistoryTableView
          allDatas={allDatas}
          isPage={isPage}
          setIsPage={setIsPage}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
          callFunction={() => getPayroleHistoryData(filters)}
          setAllFilters={setAllFilters}
          allFilters={allFilters}
        />
      {/* </div> */}
    </>
  );
};

export default History;
